import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
    ...zhLocale,
    tabs: {
        // 全局策略
        // 
        regex: '内容过滤',
        ipw: 'IP白名单',
        ipw1: '白名单',
        white_list: '白名单列表',
        ipb: 'IP黑名单',
        ipb1: '黑名单',
        fromw: '发件人白名单',
        fromb: '发件人黑名单',
        urlw: 'Url白名单',
        urlb: 'Url黑名单',
        regexw: '内容白名单',
        avoid: '防伪名字列表',
        Recipient: '收件人黑名单',
        send_email: '收件人白名单',
        categories: '不同类别个性化',

    },
    table1: {
        export_email: '导出记录',
        // 1
        order: '序号',
        type: '表达式类型',
        score: '分数',
        header: '信头key',
        rule: '正则表达式过滤规则',
        policy: '策略类型',
        operation: '操作',
        addrule: '添加过滤规则',
        addrule1: '编辑过滤规则',
        ditt: '编辑',
        verify: '验证',
        delete: '删除',
        save: '保存',
        // 2
        ipAddress: 'IP地址',
        expire: '到期时间',
        description: '描述',
        addwip: '增加ip白名单',
        impwip: '导入ip白名单',
        expwip: '导出ip白名单',
        // 3
        addbip: '增加ip黑名单',
        impbip: '导入ip黑名单',
        expbip: '导出ip黑名单',

        // 4
        yuming: '域名或邮箱账号',
        addws: '增加发件人白名单',
        impws: '导入发件人白名单',
        expws: '导出发件人白名单',
        // 5

        addbs: '增加发件人黑名单',
        impbs: '导入发件人黑名单',
        expbs: '导出发件人黑名单',

        // 6
        url: 'URL',
        addub: '添加url黑名单',
        // 7
        adduw: '添加url白名单',
        // 8
        addwcr: '添加内容白名单',
        addwcr_edit: '编辑内容白名单',
        // 9
        forge: '防伪名字',
        addnamef: '增加防伪名字',
        addfs: '设置防伪提示',
        upnf: '上传防伪名字列表文件',
        // 10
        addbr: '增加收件人黑名单',
        impbr: '导入收件人黑名单',
        expbr: '导出收件人黑名单',
        addrecws: '增加收件人白名单',
        imprecws: '导入收件人白名单',
        exprecws: '导出收件人白名单',

    },
    anti_gs1: {
        // 1
        User_type: '类型',
        Score: '分数',
        Headerkey: '信头key',
        RegexRule: '正则表达式过滤',
        Policytype: '策略类型',
        // 2
        ipaddress: 'IP地址',
        into_local: '加入本地网络(vip)',
        into_local1: '是否vip',
        // 4
        doemailaddress: '域名或邮箱账号',
        // 6
        BlackURL: 'Url黑名单',
        //7
        WhiteURL: 'Url白名单',
        // 8
        AddTag: '主题增加标记',
        //10

    },
    anti_gs1_tan: {
        del: '确定要删除吗?',
        del1: '删除成功',
        del3: '添加成功',
        del4: '暂无数据，返回列表',
        del2: '已取消删除',
        down_load: "打包选中邮件并下载?",
        down_load_cancel: "已取消下载",
        pass_email: "确定放行邮件吗?",
        pass_email_cancel: "已取消放行",
        save_sueecss: '保存成功',
        save_sueecss3: '上报成功',
        save_sueecss1: '升级成功!',
        save_sueecss2: '数据加载完成',
        rsync_sueecss: '同步成功',
        select_time: '请选择设置时间',
        auth_sueecss: '认证成功',
        cancel_send1: '确定对此邮件进行相关操作吗？',
        cancel_send2: '取消成功',
        immediate_delivery: '投递成功',
        message_load: '正在解析邮件，请等待',
        save_load: '保存中，请稍后...',
        search_load: '查询中，请稍后...',
        keyword: '关键字选项不能为空',
        check_list: '请至少勾选一项，再进行操作',
        delivery_again: '再次投递',
        delivery_again_hint: '确定对此邮件再次进行投递吗？',
        move_up: '上移吗?',
        down_up: '下移吗?',
        sure_will: '确定要将',
        sure_will_false: '已取消',

    }
}